module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE+SURBVHgBjdJLTgJBEAbgrp7msRNPIN5AbiBLnZgwJ8CJPDJxATdgbsDKEB4yegJ8BMYdcAO8AUfAlfPqKmdIxoxAZGrX3fk69VcKrJ5dJIETIiiw41UAYCs3cHWBCs0xQL1u3CxSQDbsT82sku+I6BAha/DRcuT3q2Fo60NgPLKrJOmUIzxJQRaPH3xfLnNKdjLqv1V2kTW0O4Rkeui+xHe/sHGvrkByDUB0H/uz9h9EWOEZt5TsRiR/1o2rdTiscpQ7BCdIrIhI53dNtbTbBd8LI1gVGG1kCIjhFwN2FuX7F8ZtQcYr15rXt7WG2uYSylG+Ye/98iBMIl3XNsn2I6wovDt4mF7sQYn+pys9LYmSeDs4jgVfwe2iwHgwmwPAwgmcZ5ai8iLXkuGaCZCgS05mRuSsNDBAWtabqvkD65GmfO+G5MoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Cart/mail2.png
// module id = 554
// module chunks = 0